import React, { useEffect } from "react";
import LoaderOverlay from "../../Components/Loader/Loader";
import { Box } from "@mui/material";
import PropertyDetailPage from "../PropertyDetailPage/PropertyDetailPage";
import PropertyCollectionList from "../PropertyCollectionList/PropertyCollectionList";
import { useGetProprtyStatusQuery } from "../../Services/auto-complete.services";
import { useSelector } from "react-redux";
import { RootState } from "../../Store/store";
import { useParams } from "react-router-dom";

const ValidateProperty = () => {

  const { user, isAuthenticated } = useSelector(
    (state: RootState) => state?.auth
  );

  // Use useParams to properly react to route changes
  const { searchQuery: routeSearchQuery } = useParams<{ searchQuery: string }>();
  const searchQuery = routeSearchQuery || "";

  const {
    data,
    isLoading,
    isFetching, // True during any request including refetches
    refetch,
  } = useGetProprtyStatusQuery(searchQuery, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isAuthenticated && user?.token) {
      refetch();
    }
  }, [isAuthenticated, user?.token, refetch]);

  // Show loader during initial load or when navigating between properties
  if (isLoading || isFetching) {
    return (
      <>
        <LoaderOverlay />
      </>
    );
  }

  const result = data?.data;

  return (
    <Box>
      {data?.data?.isCache || data?.data?.propertyId ? (
        <PropertyDetailPage {...result} />
      ) : (
        <PropertyCollectionList {...result} />
      )}
    </Box>
  );
};

export default ValidateProperty;
